import { useCustomTestsSearch } from 'pages/custom_tests_v1/components/custom_tests_search/context';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Form, Row } from 'react-bootstrap';

export const SearchFilters = props => {

    const { categories, categoryId, createdBy, fetchTests, handleCategoryChange, handleSearchKeyDown, loading, minScore,
        modeId, productId, products, setCreatedBy, setMinScore, setModeId, setProductId, setStatusId, setTestName,
        statusId, testName } = useCustomTestsSearch();

    const { formatMessage } = useIntl();

    return (
        <Row className="align-items-end mb-3">

            <Col className="mb-2" lg={2} sm={6} xs={12}>
                <GMetrixInput
                    disabled={loading}
                    label={formatMessage({ id: 'test_name.77ea159f', defaultMessage: 'Test Name' })}
                    onChange={e => setTestName(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                    size="sm"
                    value={testName}
                />
            </Col>

            <Col className="mb-2" lg={2} sm={6} xs={12}>
                <GMetrixInput
                    disabled={loading}
                    label={formatMessage({ id: 'created_by.1ae66f0e', defaultMessage: 'Created By', description: 'Gridview header' })}
                    onChange={e => setCreatedBy(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                    size="sm"
                    value={createdBy}
                />
            </Col>

            <Col className="mb-2" lg={2} sm={6} xs={12}>
                <Form.Group>
                    <Form.Label className={'fw-bold'}>
                        {<FormattedMessage defaultMessage="Category" id="category.f324da36" />}
                    </Form.Label>
                    <Form.Select
                        disabled={loading}
                        onChange={e => handleCategoryChange(parseInt(e.target.value))}
                        size="sm"
                        value={categoryId}
                    >
                        <option value={0}>
                            {formatMessage({ id: 'all.6feedc20', defaultMessage: 'All' })}
                        </option>
                        {categories.map(({ Id, Name }) => (
                            <option key={Id} value={Id}>
                                {Name}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col className="mb-2" lg={2} sm={6} xs={12}>
                <Form.Group>
                    <Form.Label className={'fw-bold'}>
                        {<FormattedMessage defaultMessage="Product" description={formatMessage({ id: 'gridview_header.884261d1', defaultMessage: 'Gridview header' })} id="product.3ff5f045" />}
                    </Form.Label>
                    <Form.Select
                        disabled={categoryId === 0 || loading}
                        onChange={e => setProductId(parseInt(e.target.value))}
                        size="sm"
                        value={productId}
                    >
                        <option value={0}>
                            {formatMessage({ id: 'all.6feedc20', defaultMessage: 'All' })}
                        </option>
                        {products.map(({ Id, Name }) => (
                            <option key={Id} value={Id}>
                                {Name}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col className="mb-2" sm="auto" xs={12}>
                <Form.Group>
                    <Form.Label className={'fw-bold'}>
                        {<FormattedMessage defaultMessage="Mode" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="mode.f65b1f2b" />}
                    </Form.Label>
                    <Form.Select
                        disabled={loading}
                        onChange={e => setModeId(parseInt(e.target.value))}
                        size="sm"
                        value={modeId}
                    >
                        <option value={0}>
                            {formatMessage({ id: 'all.6feedc20', defaultMessage: 'All' })}
                        </option>
                        <option value={1}>
                            {formatMessage({ id: 'training.1487a481', defaultMessage: 'Training', description: 'training mode' })}
                        </option>
                        <option value={2}>
                            {formatMessage({ id: 'testing.05ed1ac8', defaultMessage: 'Testing', description: 'testing mode' })}
                        </option>
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col className="mb-2" sm="auto" xs={12}>
                <Form.Group>
                    <Form.Label className={'fw-bold'}>
                        {<FormattedMessage defaultMessage="Status" id="status.ad856ad7" />}
                    </Form.Label>
                    <Form.Select
                        disabled={loading}
                        onChange={e => setStatusId(parseInt(e.target.value))}
                        size="sm"
                        value={statusId}
                    >
                        <option value={-1}>
                            {formatMessage({ id: 'all.6feedc20', defaultMessage: 'All' })}
                        </option>
                        <option value={1}>
                            {formatMessage({ id: 'active.b9616c88', defaultMessage: 'Active' })}
                        </option>
                        <option value={0}>
                            {formatMessage({ id: 'inactive.5fb6d21a', defaultMessage: 'Inactive' })}
                        </option>
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col className="mb-2" sm="auto" xs={12}>
                <GMetrixInput
                    disabled={loading}
                    label={formatMessage({ id: 'min_score_percent.c973442f', defaultMessage: 'Min Score (%)' })}
                    max={100}
                    min={0}
                    onChange={e => setMinScore(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                    size="sm"
                    type="number"
                    value={minScore}
                />
            </Col>

            <Col className="mb-2 d-flex align-items-end" sm="auto" xs={12}>
                <GMetrixButton
                    className="btn-sm"
                    disabled={loading}
                    iconClass="fa-solid fa-magnifying-glass"
                    onClick={fetchTests}
                    variant="outline-primary"
                >
                    {<FormattedMessage defaultMessage="Search" id="search.0ab06b2c" />}
                </GMetrixButton>
            </Col>

        </Row>
    );

};